<template>
  <is-link
    :is_link="Boolean(route_to_home)"
    :href="route_to_home"
    class="main_head-logo">
    <img :src="img_link"
         alt="Main logo">
  </is-link>
</template>

<script>

const GREEN_LOGO = '/images/logo.svg'
const WHITE_LOGO = '/images/logo-white.svg'

import IsLink from "../slots/IsLink.vue";
import {mapGetters} from "vuex";

export default {
  name: "LogoLink",
  components: {IsLink},
  props: {
    change_mobile_logo: {
      type: Boolean,
      default: false
    },
    green_logo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    img_link() {
      if (!this.getIsMobile) return GREEN_LOGO
      return this.green_logo ? GREEN_LOGO : WHITE_LOGO
    },
    route_to_home() {
      return this.$context?.route_to_home || ''
    },
    main_head_logo_props() {
      if (!this.route_to_home) return {}
      return {
        href: this.route_to_home
      }
    }
  }
}
</script>
